import { render, staticRenderFns } from "./FastProposal.vue?vue&type=template&id=6d480e60&scoped=true&"
import script from "./FastProposal.vue?vue&type=script&lang=js&"
export * from "./FastProposal.vue?vue&type=script&lang=js&"
import style0 from "./FastProposal.vue?vue&type=style&index=0&id=6d480e60&prod&scoped=true&lang=css&"
import style1 from "./FastProposal.vue?vue&type=style&index=1&id=6d480e60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d480e60",
  null
  
)

export default component.exports